import { useState } from 'react';
import styles from './W_PaymentSubscribePlan.module.css';
import O_PlanRadio from '../../O_Organisms/O_PlanRadio/O_PlanRadio';
import A_CostResult from '@/components/A_Atoms/A_CostResult/A_CostResult';
import W_PaymentDetails from '../W_PaymentDetails/W_PaymentDetails';
import W_PaymentActions from '../W_PaymentActions/W_PaymentActions';
import { generateRequestId } from '@/utils/generators';
import { calculatePaymentDate } from '@/utils/dateCalculations';
import {
  calculateSubscriptionCost,
  SubscriptionPlan,
} from '@/utils/costCalculations';
import { useTimer } from '@/hooks/useTimer';
import { useLanguage } from '@/contexts/LanguageContext';
import { getTranslation } from '@/constants/translations';

export default function W_PaymentSubscribePlan() {
  const { language } = useLanguage();
  const t = (key: string) => getTranslation(language, key);
  const [activePlan, setActivePlan] = useState<SubscriptionPlan>('year');
  const [requestId] = useState(generateRequestId());
  const remainingTime = useTimer(15);

  const handleChange = (value: string) => {
    setActivePlan(value as SubscriptionPlan);
  };

  const costCalculation = calculateSubscriptionCost(activePlan);

  return (
    <div className={styles.wrapper}>
      <div className={styles.content}>
        <h4 className={styles.title}>
          {t('payment.subscribePlan.choosePlan')}
        </h4>
        <div className={styles.plans_wrapper}>
          <O_PlanRadio
            name='year'
            value='year'
            label={t('payment.subscribePlan.yearPlan')}
            price={100}
            isDiscounted={true}
            discount={50}
            isActive={activePlan === 'year'}
            onChange={handleChange}
          />
          <O_PlanRadio
            name='month'
            value='month'
            label={t('payment.subscribePlan.monthPlan')}
            price={200}
            isDiscounted={false}
            discount={0}
            isActive={activePlan === 'month'}
            onChange={handleChange}
          />
        </div>
        <div className={styles.cost_result_wrapper}>
          <A_CostResult
            number={costCalculation.preliminaryTotal}
            text={t('payment.subscribePlan.preliminaryTotal')}
            isDiscounted={false}
          />
          <A_CostResult
            number={costCalculation.discount}
            text={t('payment.subscribePlan.discount')}
            isDiscounted={true}
          />
          <A_CostResult
            number={costCalculation.finalTotal}
            text={t('payment.subscribePlan.total')}
            isDiscounted={false}
          />
        </div>
      </div>
      <W_PaymentActions
        price={costCalculation.finalTotal}
        remainingTime={remainingTime}
        requestId={requestId}
      />
      <W_PaymentDetails date={calculatePaymentDate(activePlan)} />
    </div>
  );
}
